import React, { useState } from "react";
import supabase from "../supabaseClient";
import "../styles/global.css";

// Reusable Button Component
const Button = ({ className, onClick, children }) => (
  <button className={className} onClick={onClick}>
    {children}
  </button>
);

// Reusable Modal Component
const Modal = ({ onClose, onContinue }) => (
  <div id="guestModal" className="modal">
    <div className="modal-content">
      <p>When you play as a guest, your information will not be saved.</p>
      <Button className="modal-button" onClick={onClose}>
        Go Back
      </Button>
      <Button className="modal-button" onClick={onContinue}>
        Continue
      </Button>
    </div>
  </div>
);

function Initial() {
  const [showModal, setShowModal] = useState(false);

  const handlePlayAsGuest = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  const redirectTo = (path) => {
    window.location.href = path;
  };

  return (
    <>
      <div class="container">
        <h1>NÄTUR</h1>
        <button
          type="button"
          class="btn btn-custom"
          onClick={() => {
            redirectTo("/login");
          }}
        >
          Login
        </button>
        <br />
        <button
          type="button"
          class="btn btn-custom"
          onClick={() => {
            redirectTo("/signup");
          }}
        >
          Sign up
        </button>
      </div>
    </>
  );
}

export default Initial;
